export const ENTITY_LABELS = {
    // Singular forms
    ENTITY: 'Registry',
    ENTITY_TYPE: 'Registry Type',
    RECORD: 'Record',
    
    // Plural forms
    ENTITIES: 'Registries',
    ENTITY_TYPES: 'Registry Types',
    RECORDS: 'Records',
    
    // Actions & specific UI strings used in the PWA
    CREATE_RECORD: 'Create Record',
    SELECT_RECORD: 'Select Record',
    UPDATE_RECORD: 'Update Record',
    LOG_RECORD: 'Log for Record',
    SELECT_RECORD_TO_UPDATE: 'Select Record to Update',
    SELECT_RECORD_TO_LOG: 'Select Record to Log',
    SELECT_OR_CREATE: 'Select or Create',
    LINK_REQUIRED: 'Please link this submission to a record to continue.',
    
    // Empty States & Messages
    NO_RECORDS: 'No Records Found',
    RECORD_CREATED: 'Record created successfully!',
    RECORD_UPDATED: 'Record updated successfully!',
    RECORD_SAVED_OFFLINE: 'Record saved offline!',
    UNNAMED_RECORD: 'Unnamed Record',
    RECORD_DETAILS: 'Record Details',
    NO_RECORDS_NEARBY: 'No records within 200m of your location.',
};
